// src/hook/usePurchases.js
import { useState } from "react";
import { useAuth } from "./";
import {
  getPurchasesApi, createPurchaseApi, updatePurchaseApi, deletePurchaseApi,
  listPurchaseAttachmentsApi, uploadPurchaseAttachmentApi, deletePurchaseAttachmentApi
} from "../api/purchases";

export function usePurchases() {
  const { auth } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [purchases, setPurchases] = useState([]);

  const getPurchases = async (params) => {
    try {
      setLoading(true);
      const data = await getPurchasesApi(auth.token, params);
      setPurchases(data);
      setLoading(false);
    } catch (e) {
      setError(e); setLoading(false);
    }
  };

  const newPurchase = async (payload) => {
    try {
      setLoading(true);
      const data = await createPurchaseApi(payload, auth.token);
      setLoading(false);
      return data;
    } catch (e) { setLoading(false); setError(e); throw e; }
  };

  const editPurchase = async (id, payload) => {
    try {
      setLoading(true);
      const data = await updatePurchaseApi(id, payload, auth.token);
      setLoading(false);
      return data;
    } catch (e) { setLoading(false); setError(e); throw e; }
  };

  const removePurchase = async (id) => {
    try {
      setLoading(true);
      await deletePurchaseApi(id, auth.token);
      setLoading(false);
      return true;
    } catch (e) { setLoading(false); setError(e); throw e; }
  };

  // attachments
  const listAttachments = (purchaseId) => listPurchaseAttachmentsApi(purchaseId, auth.token);
  const uploadAttachment = (args) => uploadPurchaseAttachmentApi(args, auth.token);
  const deleteAttachment = (id) => deletePurchaseAttachmentApi(id, auth.token);

  return {
    loading, error, purchases,
    getPurchases, newPurchase, editPurchase, removePurchase,
    listAttachments, uploadAttachment, deleteAttachment,
  };
}
